import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './form-data-v2.actions';
import { MatterFormsV2 } from '@models/matter-forms';
import {
	FirestoreStateBaseForMatterWithSubscription,
	MatterWithSubscriptionStateModel,
} from '@state/FirestoreStateBaseForMatter';
import { CollectionPaths } from '@models/collections';
import { DEFAULT_STATE_BASE } from '@state/FirestoreStateBase';

export interface MatterFormV2DataStateModel
	extends MatterWithSubscriptionStateModel {
	items: MatterFormsV2[];
}
type Ctx = StateContext<MatterFormV2DataStateModel>;

const DEFAULT_STATE: MatterFormV2DataStateModel = {
	...DEFAULT_STATE_BASE,
	items: [],
};

@State<MatterFormV2DataStateModel>({
	name: 'matterFormDataV2',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class MatterFormV2DataState extends FirestoreStateBaseForMatterWithSubscription<
	MatterFormsV2,
	MatterFormV2DataStateModel
> {
	@Selector([MatterFormV2DataState])
	static getAllFormData(state: MatterFormV2DataStateModel): MatterFormsV2[] {
		return state?.items;
	}

	constructor() {
		super(
			(pathParams) =>
				CollectionPaths.business_matter_formDataV2(
					pathParams.businessId,
					pathParams.matterId,
				),
			(payload) => ({ items: payload as MatterFormsV2[] }),
			() => DEFAULT_STATE,
		);
	}

	@Action(actions.Create)
	set(ctx: Ctx, { payload }: actions.Create): void {
		this.repo.CreateOrMerge(payload.id, payload);
	}

	@Action(actions.SetField)
	setField(ctx: Ctx, { payload }: actions.SetField): void {
		this.repo.OverwriteFields(
			payload.id,
			`fields.${payload.field}.override`,
			payload.value,
		);
	}
}
